import { useEffect, useEffectEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import { QueryStatus } from '@reduxjs/toolkit/query';

import { debounce } from 'shared/utils';

import { useNotificationsMarkAsReadCreateMutation } from '../api/api';
import { CONFIG } from '../consts/config';
import { setReadNotifications } from '../model/notificationsSlice';

const debounsedSetRead = debounce((args) => {
	const [callback] = args as [() => void];
	callback();
}, CONFIG.READ_DEBOUNCE);

export const useReadNotifications = () => {
	const [viewedNotifications, setViewedNotifications] = useState(new Set<number>());
	const [setRead, { status }] = useNotificationsMarkAsReadCreateMutation();
	const dispatch = useDispatch();

	const onSuccessRead = useEffectEvent(() => {
		setViewedNotifications(new Set<number>());
	});

	useEffect(() => {
		if (status === QueryStatus.fulfilled) {
			onSuccessRead();
		}
	}, [status]);

	useEffect(() => {
		if (viewedNotifications.size > 0) {
			debounsedSetRead(() => {
				setRead({ ids: [...viewedNotifications] });
				dispatch(setReadNotifications([...viewedNotifications]));
			});
		}
	}, [viewedNotifications, setRead, dispatch]);

	return {
		appendReadNotification: (id: number) => {
			setViewedNotifications((prevState) => new Set([...prevState, id]));
		},
		setRead,
		viewedNotifications,
	};
};
